import { createContext } from 'react';

const NavContext = createContext({
  select: 0,
  changeSelect: () => {},
});
export default NavContext;
